// extracted by mini-css-extract-plugin
module.exports = {"rankProgress":"ProfileCompetition_rankProgress__Mi7BC","progressTrack":"ProfileCompetition_progressTrack__OGAB8","achievements":"ProfileCompetition_achievements__B9Rlp"};